export function cx(...parts) {
    return parts.filter((p) => typeof p === 'string' && p.length > 0).join(' ');
}
//# sourceMappingURL=cx.js.map